module.exports = __webpack_public_path__ + "img/head-bg.7a75f593.png";